var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activity-layout',[[_c('nav-menu',{staticClass:"nav-menu",attrs:{"activeTab":_vm.activeTab,"menuTab":_vm.menuTab},on:{"change":_vm.onMenuTabChange}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('comments',{staticClass:"comments"})],_vm._v(" "),_c('template',{slot:"right-aside"},[_c('right-aside',{attrs:{"buttonName":_vm.$t('global.上传作品'),"data":_vm.asideData}})],1)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-631e201c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activity/Match.vue
// module id = null
// module chunks = 